import { defineMessages } from 'react-intl'

const scope = `procurify.components.CreditCardLabel`

export default defineMessages({
  last4Digits: {
    id: `${scope}.last4Digits`,
    defaultMessage: 'Last 4 digits',
  },
})
